
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moja-karta/wymiana-karty/sim/dodaj-pelny-sim",
      function () {
        return require("private-next-pages/moje-konto/moja-karta/wymiana-karty/sim/dodaj-pelny-sim.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moja-karta/wymiana-karty/sim/dodaj-pelny-sim"])
      });
    }
  